import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { loadCss } from "helpers/function";
import LoadingTable from "views/components/LoadingTable";
import { DeleteConfirmation } from "views/components/ConfirmationAlert";
import { confirmDeleteConfig } from "config/confirmConfig";
import appConfig from "config/appConfig";
import ExportButton from "views/components/ExportButton";
import { ERROR_401 } from "config/errorPage";

import { useEndpoints } from "hooks/clients/useEndpoints";
import { usePermissions } from "hooks/clients/usePermissions";
import { useClients } from "hooks/clients/useClients";

import PageHeader from "components/clients/PageHeader";
import ClientSearch from "components/clients/ClientSearch";
import ClientTable from "components/clients/ClientTable";
import InfirmationTable from "views/components/InfirmationTable";
import HeaderTablePage from "views/components/HeaderTablePage";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const Clients = ({ userPermissions, plan }) => {
  const { t, ready } = useTranslation();

  useEffect(() => {
    document.title = `Satis client - ${ready ? t("Paramètre client") : ""}`;
  }, [ready, t]);

  const endPoint = useEndpoints(plan, userPermissions);

  const permissions = usePermissions(userPermissions);

  const {
    loading,
    clients,
    showList,
    pagination,
    error,
    deleteClient,
    searchClients,
    handlePageChange,
    handleNextPage,
    handlePreviousPage,
    handleItemsPerPageChange,
  } = useClients(endPoint);

  // Handle delete confirmation
  const handleDeleteClient = (accountId, index) => {
    DeleteConfirmation.fire(confirmDeleteConfig()).then((result) => {
      if (result.value) {
        deleteClient(accountId, index);
      }
    });
  };

  if (!ready) {
    return null;
  }

  // Redirect if no permission
  if (!permissions.canViewClients) {
    window.location.href = ERROR_401;
    return null;
  }

  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <PageHeader title={t("Paramètres")} subtitle={t("Client")} />

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <InfirmationTable information={t("Liste des clients")} />

        <div className="kt-portlet">
          {permissions.canAddClient && (
            <HeaderTablePage
              title={t("Client")}
              addText={t("Ajouter")}
              addLink="/settings/any/clients/add"
            />
          )}

          <div className="kt-portlet__body">
            <div
              id="kt_table_1_wrapper"
              className="dataTables_wrapper dt-bootstrap4"
            >
              <div className="row">
                <div className="col-sm-6 text-left">
                  <ClientSearch onSearch={searchClients} />
                </div>
                <ExportButton
                  pageUrl={permissions.canAddClient && "/settings/importClients"}
                  downloadLink={permissions.canAddClient && `${appConfig.apiDomaine}/download-excel/clients`}
                />
              </div>

              {loading ? (
                <LoadingTable />
              ) : (
                <ClientTable
                  clients={clients}
                  showList={showList}
                  pagination={pagination}
                  permissions={permissions}
                  onDelete={handleDeleteClient}
                  handlePageChange={handlePageChange}
                  handleNextPage={handleNextPage}
                  handlePreviousPage={handlePreviousPage}
                  handleItemsPerPageChange={handleItemsPerPageChange}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
    plan: state.plan.plan,
  };
};

export default connect(mapStateToProps)(Clients);
